module.exports = __webpack_public_path__ + "static/img/product.c4501c3f.png";